import * as types from "../constants/adminConstants";

const initialState = {
  logs: [],
  servicePreferences: null,
  fileUploadSettings: null,
  communities: null,
  deletedCommunities: null,
  community: null,
  moderators: null,
  reportedPosts: null,
  adminPanelError: null,
  signInError: null,
};

const adminReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SIGN_IN_SUCCESS:
      return {
        ...state,
        signInError: null,
      };
    case types.SIGN_IN_FAIL:
      return {
        ...state,
        signInError: payload ? payload : null,
      };

    case types.LOGOUT_SUCCESS:
      return {
        ...state,
        adminAccessToken: null,
        logs: [],
        servicePreferences: null,
        communities: null,
        community: null,
        moderators: null,
        adminPanelError: null,
        signInError: null,
        fileUploadSettings: null,
      };
    case types.GET_LOGS_SUCCESS:
      return {
        ...state,
        logs: payload ? payload : [],
        adminPanelError: null,
      };

    case types.GET_LOGS_FAIL:
      return {
        ...state,
        logs: [],
        adminPanelError: payload ? payload : [],
      };

    case types.DELETE_LOGS_SUCCESS:
      return {
        ...state,
        logs: [],
        adminPanelError: null,
      };

    case types.DELETE_LOGS_FAIL:
      return {
        ...state,
        logs: null,
        adminPanelError: payload ? payload : [],
      };

    case types.GET_SERVICE_PREFERENCES_SUCCESS:
      return {
        ...state,
        servicePreferences: payload ? payload : null,
        adminPanelError: null,
      };

    case types.GET_SERVICE_PREFERENCES_FAIL:
      return {
        ...state,
        servicePreferences: null,
        adminPanelError: payload ? payload : null,
      };

    case types.UPDATE_SERVICE_PREFERENCES_SUCCESS:
      return {
        ...state,
        servicePreferences: payload ? payload : null,
        adminPanelError: null,
      };

    case types.GET_COMMUNITIES_SUCCESS:
      return {
        ...state,
        communities: payload ? payload : null,
        adminPanelError: null,
      };

    case types.GET_COMMUNITIES_FAIL:
      return {
        ...state,
        communities: null,
        adminPanelError: payload ? payload : null,
      };

    case types.GET_COMMUNITY_SUCCESS:
      return {
        ...state,
        community: payload ? payload : null,
        adminPanelError: null,
      };
    case types.GET_COMMUNITY_FAIL:
      return {
        ...state,
        community: null,
        adminPanelError: payload ? payload : null,
      };

    case types.GET_MODERATORS_SUCCESS:
      return {
        ...state,
        moderators: payload ? payload : null,
        adminPanelError: null,
      };
    case types.GET_MODERATORS_FAIL:
      return {
        ...state,
        moderators: null,
        adminPanelError: payload ? payload : null,
      };
    case types.ADD_MODERATOR_SUCCESS:
      return {
        ...state,
        adminPanelError: null,
      };
    case types.ADD_MODERATOR_FAIL:
      return {
        ...state,
        adminPanelError: payload ? payload : null,
      };
    case types.REMOVE_MODERATOR_SUCCESS:
      return {
        ...state,
        adminPanelError: null,
      };
    case types.REMOVE_MODERATOR_FAIL:
      return {
        ...state,
        adminPanelError: payload ? payload : null,
      };
    case types.CREATE_COMMUNITY_SUCCESS:
      return {
        ...state,
        communities: payload ? [...(state.communities || []), payload.community] : state.communities,
        adminPanelError: null,
      };
    case types.CREATE_COMMUNITY_FAIL:
      return {
        ...state,
        adminPanelError: payload ? payload : null,
      };
    case types.UPDATE_COMMUNITY_SUCCESS:
      return {
        ...state,
        communities: state.communities ? state.communities.map(community => 
          community._id === payload.community._id ? payload.community : community
        ) : state.communities,
        community: state.community && state.community._id === payload.community._id ? payload.community : state.community,
        adminPanelError: null,
      };
    case types.UPDATE_COMMUNITY_FAIL:
      return {
        ...state,
        adminPanelError: payload ? payload : null,
      };
    case types.DELETE_COMMUNITY_SUCCESS:
      return {
        ...state,
        communities: state.communities ? state.communities.filter(community => community._id !== payload) : state.communities,
        community: state.community && state.community._id === payload ? null : state.community,
        adminPanelError: null,
      };
    case types.DELETE_COMMUNITY_FAIL:
      return {
        ...state,
        adminPanelError: payload ? payload : null,
      };
    case types.GET_DELETED_COMMUNITIES_SUCCESS:
      return {
        ...state,
        deletedCommunities: payload ? payload : null,
        adminPanelError: null,
      };
    case types.GET_DELETED_COMMUNITIES_FAIL:
      return {
        ...state,
        deletedCommunities: null,
        adminPanelError: payload ? payload : null,
      };
    case types.RESTORE_COMMUNITY_SUCCESS:
      return {
        ...state,
        deletedCommunities: state.deletedCommunities ? state.deletedCommunities.filter(community => community._id !== payload) : state.deletedCommunities,
        communities: state.communities ? [...(state.communities || []), state.deletedCommunities?.find(community => community._id === payload)] : state.communities,
        adminPanelError: null,
      };
    case types.RESTORE_COMMUNITY_FAIL:
      return {
        ...state,
        adminPanelError: payload ? payload : null,
      };
    case types.GET_FILE_UPLOAD_SETTINGS_SUCCESS:
      return {
        ...state,
        fileUploadSettings: payload ? payload.settings : null,
        adminPanelError: null,
      };
    case types.GET_FILE_UPLOAD_SETTINGS_FAIL:
      return {
        ...state,
        fileUploadSettings: null,
        adminPanelError: payload ? payload : null,
      };
    case types.UPDATE_FILE_UPLOAD_SETTINGS_SUCCESS:
      return {
        ...state,
        adminPanelError: null,
      };
    case types.UPDATE_FILE_UPLOAD_SETTINGS_FAIL:
      return {
        ...state,
        adminPanelError: payload ? payload : null,
      };
    case types.GET_REPORTED_POSTS_SUCCESS:
      return {
        ...state,
        reportedPosts: payload ? payload : null,
        adminPanelError: null,
      };
    case types.GET_REPORTED_POSTS_FAIL:
      return {
        ...state,
        reportedPosts: null,
        adminPanelError: payload ? payload : null,
      };
    case types.REMOVE_REPORTED_POST_SUCCESS:
      return {
        ...state,
        reportedPosts: state.reportedPosts
          ? {
              ...state.reportedPosts,
              reportedPosts: state.reportedPosts.reportedPosts?.filter(
                (report) => report._id !== payload
              ) || [],
              total: (state.reportedPosts.total || 0) - 1,
            }
          : null,
        adminPanelError: null,
      };
    case types.REMOVE_REPORTED_POST_FAIL:
      return {
        ...state,
        adminPanelError: payload ? payload : null,
      };
    case types.DELETE_REPORTED_POST_SUCCESS:
      return {
        ...state,
        reportedPosts: state.reportedPosts
          ? {
              ...state.reportedPosts,
              reportedPosts: state.reportedPosts.reportedPosts?.filter(
                (report) => report._id !== payload
              ) || [],
              total: (state.reportedPosts.total || 0) - 1,
            }
          : null,
        adminPanelError: null,
      };
    case types.DELETE_REPORTED_POST_FAIL:
      return {
        ...state,
        adminPanelError: payload ? payload : null,
      };
    default:
      return state;
  }
};

export default adminReducer;
